import _ from 'lodash';
import {
    useQuery
} from 'react-query';

// metricRequestsByKey should be an object where each value is a metric request and the
// key is some arbitrary string that is meaningful to the caller (it's opaque to this hook).
// The returned results will be keyed by the keys from metricRequestsByKey. If the requests
// passed in is an array, the result will be a parallel array.
function useMetrics(metricRequestsByKey, options) {

    const canonicalizedMetricRequestsByKey = _.mapValues(metricRequestsByKey, (metricRequest, key) => {
        const validationErrors = RivalIQ.metrics.new.MetricRequest.validateMetricRequest(metricRequest);
        const hasValidationErrors = !_.isEmpty(validationErrors);
        if (hasValidationErrors) {
            throw new Error(`Metric request validation error: ${validationErrors}`);
        } else {
            metricRequest = _.extend({
                ___requestGroup: options?.requestGroup || 'defaultRequestGroup'
            }, metricRequest);
            return RivalIQ.metrics.new.MetricRequest.canonicalizeMetricRequest(metricRequest);
        }
    });

    const requestKeyToUUID = _.mapValues(canonicalizedMetricRequestsByKey, canonicalizedMetricRequest => RivalIQ.metrics.new.MetricRequest.uniqueKeyForMetricRequest(canonicalizedMetricRequest));
    const requestKeys = _.values(requestKeyToUUID).sort().join('|');
    return useQuery(['metrics', requestKeys], async () => {
        const allMetricRequestKeys = _.keys(metricRequestsByKey).sort();
        const metricRequests = _.map(allMetricRequestKeys, key => canonicalizedMetricRequestsByKey[key]);
        const results = await RivalIQ.metrics.new.client.CacheLayer.fetch(metricRequests);

        const resultsByKey = _.reduce(allMetricRequestKeys, (memo, key, idx) => {
            memo[key] = results[idx];
            return memo;
        }, _.isArray(metricRequestsByKey) ? [] : {});
        return resultsByKey;
    });
}

export default useMetrics;
